<template>
  <ul class="list">
    <li v-for="(i,index) in list" :key="index" :class="{action:listT == index}" @click="$emit('qie',index)">
      <div class="iconfont" :class="i.img"></div>
      <div class="">
        <div class="name">{{i.name}}</div>
        <div class="desc" v-html="i.desc"></div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'list',
  props: {
    list: Array,
    listT: Number
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="stylus" scoped>
.list
  padding px(30) px(20)
  display flex
  flex-flow row wrap
  justify-content space-between
  li
    width px(345)
    // height px(180)
    margin-bottom px(20)
    border-radius 4px
    padding px(20) px(10)
    border 1px solid #D8D8D8
    position relative
    display flex
    align-items center
    .iconfont
      font-size px(60)
      color #D22016
      margin-right px(10)
    .desc
      color #666666
      font-size px(20)
      line-height px(35)
    .name
      color #333333
      font-size px(24)
</style>



// WEBPACK FOOTER //
// src/pages/index/components/list.vue